var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardMainHeaderUpload = function SvgIconDashboardMainHeaderUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M4.165 13.898A.56.56 0 0 1 4 13.5v-2.812h1.125v2.25H13v-2.25h1.125V13.5c0 .31-.252.563-.562.563h-9a.56.56 0 0 1-.398-.165",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M1 3C1 1.86 1.923.938 3.063.938h12c1.139 0 2.062.923 2.062 2.062v12c0 1.14-.923 2.063-2.062 2.063h-12A2.06 2.06 0 0 1 1 15zm2.063-.937A.937.937 0 0 0 2.125 3v12c0 .518.42.938.938.938h12c.517 0 .937-.42.937-.938V3a.937.937 0 0 0-.937-.937z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "m6.393 6.374 2.272-2.272c.22-.22.576-.22.796 0l2.273 2.272-.796.796-1.875-1.875L7.188 7.17z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M8.5 11.063V4.5a.563.563 0 0 1 1.125 0v6.563z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDashboardMainHeaderUpload;